export default __webpack_public_path__ + "static/media/Muhammad_Ibrahim.c03d6b56.png";